import { BaseService } from "Service/BaseService";
import { Configuration } from "Configuration";

import { RefreshCacheProvider, RefreshCacheClient } from "./Client";

/**
 * Service for global search.
 * @hidden
 */
export class RefreshCacheService extends BaseService {
    /**
     * Get dms version info.
     * @param gridId Grid ID.
     * @param filterId Filter ID.
     * @param textBlockCategory TextBlockCategory.
     * @param commandOption CommandOption.
     */
    public get(): Promise<RefreshCacheProvider[]> {
        let client = new RefreshCacheClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();
        return new Promise<RefreshCacheProvider[]>((resolve, reject) => {
            /* let xhr =*/ client.get(
                (res) => {
                    resolve(res);
                },
                (exception, reason) => {
                    reject(reason);
                }
            );
            // token.onCancelled((reason) => {
            //     xhr.abort();
            //     reject(reason);
            // });
        });
    }

    public refresh(keys: string[]): Promise<string[]> {
        let client = new RefreshCacheClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();
        return new Promise<string[]>((resolve, reject) => {
            /* let xhr =*/ client.refresh(
                keys,
                (res) => {
                    resolve(res);
                },
                (exception, reason) => {
                    reject(reason);
                }
            );
            // token.onCancelled((reason) => {
            //     xhr.abort();
            //     reject(reason);
            // });
        });
    }
}
